import { get } from 'lodash';
import { fetch } from '@utils/utils';

export const getSequenceId = ({ addError }) => async (key: string): Promise<string | null> => {
  try {
    const response: any = await fetch('/metropolis/api/settings/general', {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const settingsObject = await response.json();
    const sequenceId = get(settingsObject, `sequenceSettings.${key}.id`, null);

    if (!sequenceId) {
      addError('Sekvenční číslo nebylo nastaveno');
    }

    return sequenceId;
  } catch (err) {
    addError('Sekvenční číslo nebylo nastaveno');
    return null;
  }
};

export const fetchSequence = ({ addError }) => async id => {
  try {
    const response = await fetch(`/metropolis/api/sequences/${id}/generate`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const result = await response.text();

    return result;
  } catch (err) {
    addError(err.message);
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/components/form/NumberSequence/_numberSequenceActions.ts